<div class="gw-rv-product">
    <div class="gw-rv-product__image">
        <slot name="image" />
    </div>
    <div class="gw-rv-product__body">
        <h3 class="gw-rv-product__title">
            <slot name="title" />
        </h3>
        <p class="gw-rv-product__vendor">
            <slot name="vendor" />
        </p>
        <span class="gw-rv-product__price">
            <slot name="price" />
        </span>
    </div>
</div>

<style lang="postcss">
    .gw-rv-product {
        display: flex;
        justify-content: center;
        gap: 1.5em;
        line-height: normal;
        width: auto;

        &__body {
            max-width: 400px;
            display: flex;
            flex-direction: column;
        }

        &__image {
            width: 6.75em;
            height: 6.75em;
            line-height: 2em;
            flex-shrink: 0;
        }

        &__title {
            font-size: 1.5em;
            line-height: normal;
            font-weight: 600;
            margin: 0;
        }

        &__vendor {
            margin: 0.75em 0 0;
            font-size: 0.875em;
            line-height: 1.13em;
            opacity: 0.5;
            /* color: #667085; */
        }

        &__price {
            font-size: 1em;
            display: inline-block;
            margin-top: 2em;
        }
    }
</style>
